// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sun-code-copy-left[data-v-f015af14]{font-size:14px;line-height:16px;overflow-y:hidden;height:calc(100% - 40px);background:#131216}", ""]);
// Exports
module.exports = exports;
